/* oxlint-disable @typescript-eslint/no-use-before-define */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'Button';
import { memo, type FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { faChevronRight, faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import './locales/StudentSpotlight/StudentSpotlight-en.json';

type Props = {
    direction?: 'left' | 'right';
    hide?: boolean;
    onPress: () => void;
};

export const ScrollArrowButton: FC<Props> = memo(({ direction = 'right', hide = false, onPress }) => (
    <ArrowButton onPress={onPress} direction={direction} hide={hide} />
));

const ArrowButton = ({
    onPress,
    direction,
    hide,
}: {
    onPress: () => void;
    direction: 'left' | 'right';
    hide: boolean;
}) => {
    const { t } = useTranslation('back_royal', { keyPrefix: 'StudentSpotlight.StudentSpotlight' });

    return (
        <Button
            isIconOnly
            aria-label={t('scroll')}
            variant="solid"
            color="white"
            onPress={onPress}
            className={twMerge(
                'absolute z-10 hidden transition-opacity ease-in-out md:inline-flex',
                hide ? 'pointer-events-none opacity-0' : 'opacity-100',
                direction === 'left' ? 'left-1.5' : 'right-1.5',
                'top-[139px]',
            )}
            round
            height={8}
        >
            <FontAwesomeIcon icon={direction === 'left' ? faChevronLeft : faChevronRight} />
        </Button>
    );
};
